export default __webpack_public_path__ + "static/media/icon-fail-graphic.b1f9e98c.png";